import { Box, Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";

import { FieldArray, useFormikContext } from "formik";
import Tabs from "../../../../../Tabs";
import { ButtonLoader } from "../../../../../inputs.styled";
import { colors } from "../../../../../../utils";
import AddSocialLinksForm from "./AddSocialLinksForm";

const tabsConfig = [
  { label: "Links", value: "Links" },
  {
    label: "Vault Design",
    value: "Vault Design",
    suffix: "Coming Soon",
  },
];

const InnerForm = ({ onClose, apiLoading }) => {
  const { handleSubmit, values, isValid, dirty } = useFormikContext();

  const [selectedTab, setSelectedTab] = useState(tabsConfig[0].value);

  const renderFormContent = () => {
    switch (selectedTab) {
      case tabsConfig[0].value:
        return (
          <FieldArray
            name="external_links"
            render={(props) => {
              return <AddSocialLinksForm {...props} />;
            }}
          />
        );
      case tabsConfig[1].value:
        return <></>;

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.white,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "10px",
        }}
      >
        <Typography
          sx={{
            color: "#0F0F0F",
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "20px",
            fontFamily: "DM Sans",
          }}
        >
          LinkVault
        </Typography>
      </Box>

      <Typography
        sx={{
          color: "#0F0F0F",
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "DM Sans",
          my: "5px",
        }}
      >
        Connect your whole online presence to your Gallery!
      </Typography>

      <Tabs
        // categories={tabsConfig.map(tab => tab.value)}
        selectedCategory={selectedTab}
        onCategoryChange={(_, val) => setSelectedTab(val)}
        tabStyle={{ maxWidth: "35%" }} // Increased to accommodate suffix
        disabledCategories={["Vault Design"]}
        categoriesWithIcons={tabsConfig}
        suffixStyle={{
          backgroundColor: "#EFE9FE",
          padding: "4px 8px",
          fontSize: "12px",
          fontWeight: "600",
          borderRadius: "20px",
          color: "#9B5AF8",
          fontFamily: "DM Sans",
          whiteSpace: "nowrap", // Prevents text wrapping
          width: "auto", // Remove fixed width to prevent wrapping
          display: "inline-block", // Keeps text in line
          marginLeft: "8px", // Add some spacing from the tab text
        }}
      />

      <Box
        sx={{
          overflowY: "auto !important",
          flex: 1,
        }}
      >
        {renderFormContent()}
      </Box>

      <Box
        sx={{
          bottom: 0,
          position: "sticky",
          backgroundColor: colors.white,
          zIndex: 2,
          p: "16px 0px 0px 16px",
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          borderTop: "1px solid #BBBBBB",
        }}
      >
        <Button
          sx={{
            color: "#495057",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "500",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          sx={{
            color: "white",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "500",
            background: "#9B5AF8",
            width: "130px",
            "&:hover": {
              background: "#9B5AF885",
            },
            "&.Mui-disabled": {
              background: "#E1E1E1",
              color: "#BBBBBB",
            },
          }}
          disabled={!isValid || !dirty || apiLoading}
        >
          {apiLoading && <ButtonLoader />} {"Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default InnerForm;
